/* import __COLOCATED_TEMPLATE__ from './phone-beta-banner.hbs'; */
/* RESPONSIBLE TEAM: team-phone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type FinVoiceConfigService from 'embercom/services/fin-voice-config-service';

export default class PhoneBetaBannerComponent extends Component {
  @service declare finVoiceConfigService: FinVoiceConfigService;

  get isTrialExperience() {
    return this.finVoiceConfigService.isTrialExperience;
  }

  get shouldShowBanner(): boolean {
    return (
      this.finVoiceConfigService.shouldShowPaywall || this.finVoiceConfigService.isTrialExperience
    );
  }

  get bannerMessage() {
    return this.isTrialExperience
      ? 'operator.fin.setup.tabs.setup-and-go-live.pricing-paywall.banner-message-trial'
      : 'operator.fin.setup.tabs.setup-and-go-live.pricing-paywall.banner-message';
  }

  get bannerIcon() {
    return this.isTrialExperience ? 'resolved' : 'phone';
  }

  @action
  talkToUs() {
    this.finVoiceConfigService.talkToUs();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Components::PhoneBetaBanner': typeof PhoneBetaBannerComponent;
  }
}
